import React from 'react';
import './LetterGradeBadge.scss';
import classnames from 'classnames';

const LetterGradeBadge = ({
  grade,
  datatestid,
  type,
  className,
  changeSizeOnMobile = true,
}) => {
  let gradeBadge = 'noGradeBadge';

  // grade is equal to either "A" , "B", "C", "D" or "F"
  if (['A', 'B', 'C', 'D', 'F'].indexOf(grade) !== -1) {
    gradeBadge = `gradeBadge${grade}`;
  }

  const badgeSize = type === 'big' ? 'bigLetterGradeBox' : 'letterGradeBox';
  const avoidChangeSizeOnMobile = changeSizeOnMobile
    ? ''
    : 'avoidChangeSizeOnMobile';
  return (
    <div
      data-testid={datatestid ? `${datatestid}-grade` : null}
      className={classnames(
        `letterGradeBadgeContainer ${badgeSize} ${gradeBadge}`,
        {
          avoidChangeSizeOnMobile,
        },
        className,
      )}
    >
      {grade}
    </div>
  );
};

export { LetterGradeBadge };
